import {
    type LensstudioMylensesAdjust,
    type LensstudioMylensesSubmit,
    type LensstudioMylensesUpdate,
    type MylensesAction,
    type MylensesCommunityAudiencePageView,
    type MylensesInsightsPageView,
    type MylensesManagementPageAction,
    type MylensesManagementPageOpen,
    type MylensesManagementPageView,
    type MylensesPageView,
    type MylensesRatingFormAction,
} from "@snapchat/blizzard-schema";

import {
    type ActionEventData,
    type AdjustEventData,
    type CommunityAudiencePageEventData,
    type FeedbackRatingFormEventData,
    type InsightsPageEventData,
    type ManagementPageActionEventData,
    type ManagementPageViewEventData,
    type PageOpenEventData,
    type PageViewEventData,
    type SubmitEventData,
    type UpdateEventData,
    createActionEvent,
    createAdjustEvent,
    createCommunityAudiencePageEvent,
    createFeedbackRatingFormActionEvent,
    createInsightsPageEvent,
    createManagementPageActionEvent,
    createManagementPageViewEvent,
    createPageOpenEvent,
    createPageViewEvent,
    createSubmitEvent,
    createUpdateEvent,
} from "../event-creators";

export type BlizzardEventData =
    | SubmitEventData
    | AdjustEventData
    | UpdateEventData
    | PageOpenEventData
    | ManagementPageActionEventData
    | ManagementPageViewEventData
    | InsightsPageEventData
    | CommunityAudiencePageEventData
    | FeedbackRatingFormEventData
    | PageViewEventData
    | ActionEventData;

export type BlizzardEvent =
    | LensstudioMylensesSubmit
    | LensstudioMylensesAdjust
    | LensstudioMylensesUpdate
    | MylensesManagementPageOpen
    | MylensesManagementPageView
    | MylensesManagementPageAction
    | MylensesInsightsPageView
    | MylensesRatingFormAction
    | MylensesCommunityAudiencePageView
    | MylensesPageView
    | MylensesAction;

export const createBlizzardEvent = (data: BlizzardEventData, sessionId: string): BlizzardEvent => {
    switch (data.event) {
        case "LENSSTUDIO_MYLENSES_SUBMIT":
            return createSubmitEvent(data);
        case "LENSSTUDIO_MYLENSES_ADJUST":
            return createAdjustEvent(data);
        case "LENSSTUDIO_MYLENSES_UPDATE":
            return createUpdateEvent(data);
        case "MYLENSES_MANAGEMENT_PAGE_OPEN":
            return createPageOpenEvent(data, sessionId);
        case "MYLENSES_MANAGEMENT_PAGE_VIEW":
            return createManagementPageViewEvent(data, sessionId);
        case "MYLENSES_MANAGEMENT_PAGE_ACTION":
            return createManagementPageActionEvent(data, sessionId);
        case "MYLENSES_INSIGHTS_PAGE_VIEW":
            return createInsightsPageEvent(data, sessionId);
        case "MYLENSES_RATING_FORM_ACTION":
            return createFeedbackRatingFormActionEvent(data, sessionId);
        case "MYLENSES_COMMUNITY_AUDIENCE_PAGE_VIEW":
            return createCommunityAudiencePageEvent(data, sessionId);
        case "MYLENSES_PAGE_VIEW":
            return createPageViewEvent(data, sessionId);
        case "MYLENSES_ACTION":
            return createActionEvent(data, sessionId);
    }
};
